import * as React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  OutlinedInput
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';

interface FormikMultiSelectProps {
  disabled?: boolean;
  label: string;
  fieldValue: {
    value: string[]; // Multi-select value as an array of strings
    onBlur?: () => void;
  };
  options: string[]; // Options as an array of strings
  handleChange: (event: SelectChangeEvent<string[]>) => void;
  isErrorField?: boolean;
  name: string;
  initialValue: string[];
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export default function FormikMultiSelect({
  disabled = false,
  label,
  fieldValue,
  options,
  handleChange,
  isErrorField = false,
  name,
  initialValue = []
}: FormikMultiSelectProps) {
  const [selectedValues, setSelectedValues] =
    React.useState<string[]>(initialValue);

  const handleMultiSelectChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value }
    } = event;
    setSelectedValues(typeof value === 'string' ? value.split(',') : value);
    handleChange(event);
  };
  React.useEffect(() => {
    setSelectedValues(initialValue);
  }, [initialValue]);

  return (
    <FormControl
      fullWidth
      className="select-drop-down-label-styling required-field"
    >
      <InputLabel
        id={`${name}-label`}
        className="input-field-dropdown-styling required-label"
      >
        {label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        multiple
        value={selectedValues}
        onChange={handleMultiSelectChange}
        onBlur={fieldValue.onBlur}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected?.join(', ')}
        MenuProps={MenuProps}
        disabled={disabled}
        error={selectedValues.length === 0 && isErrorField}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={selectedValues.includes(option)} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
